import { render, staticRenderFns } from "./InstitutionSchedule.vue?vue&type=template&id=16e01dfc"
import script from "./InstitutionSchedule.vue?vue&type=script&lang=js"
export * from "./InstitutionSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports